import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b107ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Baixar Planilha", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Importar Pessoas", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_7 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_8 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn",
  style: {"min-height":"200px!important"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "ant-upload-drag-icon" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ant-upload-drag-icon" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Clique para selecionar ou arraste o arquivo excel até aqui.", -1))
const _hoisted_15 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = { key: 5 }
const _hoisted_22 = {
  key: 6,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de Pessoa:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "CPF/CNPJ:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Relações:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de Atividade:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Nome/Razão Social:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Nome Fantasia:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Telefone:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "E-mail:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "CEP:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Endereço/Avenida/Rua:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Número:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Complemento:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Bairro:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cidade/UF:", -1))
const _hoisted_37 = { key: 7 }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-21 ant-col-xl-21" }, null, -1))
const _hoisted_42 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_cidade = _resolveComponent("selecionar-cidade")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: 'Importação de Pessoas pelo Excel',
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    "wrap-class-name": "scroll-modal ss-modal-cadastros"
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.baixarArquivo && _ctx.baixarArquivo(...args)))
        }, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.importarPessoas && _ctx.importarPessoas(...args)))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.state.cacheDisponivel)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    style: {"width":"100%"},
                    "show-icon": "",
                    closable: ""
                  }, {
                    message: _withCtx(() => [
                      _createTextVNode(" Você possui a importação do arquivo: " + _toDisplayString(_ctx.state.nomeArquivo) + " em andamento, deseja recuperar? ", 1),
                      _createVNode(_component_a_button, {
                        onClick: _ctx.recuperarCache,
                        size: "small",
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.state.mensagemErro !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_a_alert, {
                    style: {"width":"100%"},
                    message: _ctx.state.mensagemErro,
                    type: "error",
                    "show-icon": ""
                  }, null, 8, ["message"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_collapse, {
              ghost: "",
              class: "ss-accordion",
              activeKey: _ctx.state.painelUpload,
              "onUpdate:activeKey": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.painelUpload) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "1",
                  header: "Envie um arquivo"
                }, {
                  default: _withCtx(() => [
                    (_ctx.modalBase.computedVisivel)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args))),
                          class: "ant-upload ant-upload-drag",
                          onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                          onDrop: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                        }, [
                          _createElementVNode("span", _hoisted_8, [
                            _createElementVNode("input", {
                              id: "selecionarArquivo",
                              type: "file",
                              accept: "",
                              multiple: "",
                              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadArquivoSelecionado && _ctx.uploadArquivoSelecionado(...args))),
                              style: {"display":"none"}
                            }, null, 32),
                            _createElementVNode("div", {
                              class: "ant-upload-drag-container",
                              onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.uploadArquivoArrastado && _ctx.uploadArquivoArrastado(...args)))
                            }, [
                              ((_ctx.state.enviandoArquivo))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("p", _hoisted_10, [
                                      _createVNode(_component_a_spin, { size: "large" })
                                    ]),
                                    _hoisted_11
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("p", _hoisted_13, [
                                      _createVNode(_component_icone, {
                                        style: {"font-size":"40px"},
                                        nome: "upload-nuvem"
                                      })
                                    ]),
                                    _hoisted_14
                                  ]))
                            ], 32)
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ]),
          (_ctx.state.pessoas.length > 0 && !_ctx.state.enviandoArquivo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_form_item, {
                    label: "Busca Rápida",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                        onKeyup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.verificarFiltro && _ctx.verificarFiltro(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.state.buscaRapida]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_card, { titulo: "Títulos no Arquivo" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                        "data-source": _ctx.state.pessoas.filter(i => i.visivel),
                        rowKey: "index",
                        pagination: false,
                        loading: _ctx.telaBase.carregando,
                        scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth +150), y: _ctx.window.innerHeight - 500 },
                        "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                        size: "small"
                      }, {
                        bodyCell: _withCtx(({ column, record, text }) => [
                          (column.key === 'DescricaoTipoPessoa')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", null, _toDisplayString(text), 1),
                                (!record.validado)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 0,
                                      placement: "top",
                                      title:  record.mensagemValidacao 
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icone, {
                                          style: {"color":"orangered"},
                                          class: "ss-icone-informacao-campo",
                                          nome: "informacao-campo"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (column.key === 'CpfCnpj')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1),
                                  (_ctx.UtilitarioGeral.validaCodigo(record.codigo))
                                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                        key: 0,
                                        placement: "top",
                                        title: "Já existe uma pessoa lançado com esse código interno!"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_icone, {
                                            style: {"color":"orangered"},
                                            class: "ss-icone-informacao-campo",
                                            nome: "informacao-campo"
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararTelefoneCelular)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(text)), 1))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                                      : (column.key === 'Pessoa')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                            _createElementVNode("span", null, [
                                              _hoisted_23,
                                              _createTextVNode(_toDisplayString(record.DescricaoTipoPessoa), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_24,
                                              _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(record.CpfCnpj)), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_25,
                                              _createTextVNode(_toDisplayString(record.DescricaoRelacoes), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_26,
                                              _createTextVNode(_toDisplayString(record.descricaoTipoAtividade), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_27,
                                              _createTextVNode(_toDisplayString(record.nome), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_28,
                                              _createTextVNode(_toDisplayString(record.nomeFantasia), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_29,
                                              _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(record.telefone)), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_30,
                                              _createTextVNode(_toDisplayString(record.email), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_31,
                                              _createTextVNode(_toDisplayString(record.cep), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_32,
                                              _createTextVNode(_toDisplayString(record.endereco), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_33,
                                              _createTextVNode(_toDisplayString(record.numero), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_34,
                                              _createTextVNode(_toDisplayString(record.complemento), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_35,
                                              _createTextVNode(_toDisplayString(record.bairro), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_36,
                                              _createTextVNode(_toDisplayString(record.nomeCidade), 1)
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(text), 1))
                        ]),
                        emptyText: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, {
                            resultadoPesquisa: !_ctx.telaBase.carregando,
                            mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                          }, null, 8, ["resultadoPesquisa", "mensagem"])
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, { titulo: "Ajustes" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_a_form_item, {
                            label: "Cidade",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_cidade, {
                                apresentarEstado: true,
                                "codigo-selecionado": _ctx.state.codigoCidade,
                                "onUpdate:codigoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.codigoCidade) = $event)),
                                "nome-selecionado": _ctx.state.nomeCidade,
                                "onUpdate:nomeSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.nomeCidade) = $event))
                              }, null, 8, ["codigo-selecionado", "nome-selecionado"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary",
                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.realizarAjustes && _ctx.realizarAjustes(...args))),
                                style: {"width":"100%"}
                              }, "Aplicar Ajustes")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            retornoRequisicao: _ctx.modalBase.retornoRequisicao,
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
          }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
        ]),
        _: 1
      }),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible"]))
}